import { cx } from '@libs/classnames';

import styles from './ClubLogo.module.css';

const DEFAULT_CLUB_LOGO = '/images/chessopen-square-logo.svg';

export type Props = {
  className?: string;
  logoUrl?: string | null;
  sponsorLogoUrl?: string | null;
};

export function ClubLogo({ className, logoUrl: _logoUrl, sponsorLogoUrl }: Props) {
  const logoUrl = sponsorLogoUrl || _logoUrl || DEFAULT_CLUB_LOGO;

  return (
    <div
      className={cx(
        styles.clubLogo,
        {
          [styles.hasSponsor]: sponsorLogoUrl,
        },
        className,
      )}
    >
      <div className={styles.logoContainer}>
        <img className={styles.image} draggable={false} alt="Logo" src={logoUrl} />
      </div>
    </div>
  );
}
